import { defineStore } from "pinia";

import type { WorkingMode } from "@/model/baseTypes";

import { useClientSettingsStore } from "./clientSettings";

interface State {
  workingMode: WorkingMode;
}

export const useWorkModeStore = defineStore("workMode", {
  state: (): State => ({ workingMode: "planning" }),
  getters: {
    isExecutionMode(): boolean {
      return this.workingMode === "execution";
    },
    isPlanningMode(): boolean {
      return this.workingMode === "planning";
    },
  },
  actions: {
    setWorkingMode(mode: WorkingMode) {
      this.workingMode = mode;
      useClientSettingsStore().setWorkingMode(mode);
    },
    toggle() {
      this.setWorkingMode(this.isExecutionMode ? "planning" : "execution");
    },
  },
});
